import { darken } from 'polished';
import React from 'react';
import styled from 'styled-components';
import { BodyRegularSemiBold } from '../../../fonts/typography/Typography';
import DotFalling from '../spinner/DotFalling';

interface OutlinedButtonProps {
  color: string;
  children: React.ReactNode;
  disabled?: boolean;
  showLoadingOnDisabled?: boolean;
  onClick: () => void;
}

const OutlinedButton = ({
  color,
  children,
  onClick,
  disabled = false,
  showLoadingOnDisabled = false,
}: OutlinedButtonProps) => {
  const action = disabled ? () => ({}) : onClick;
  return (
    <OutlinedStyles onClick={action} color={color} disabled={disabled}>
      {disabled && showLoadingOnDisabled ? <DotFalling color={color} /> : children}
    </OutlinedStyles>
  );
};

const OutlinedStyles = styled.button<OutlinedButtonProps>`
  ${BodyRegularSemiBold}
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 40px;
  border-radius: 5px;
  border: 1px solid ${(props) => props.color};
  padding: 8px;
  color: ${(props) => props.color};
  transition: border 0.1s ease-in, color 0.1s ease-in;
  cursor: ${(props) => (props.disabled ? 'progress' : 'pointer')};
  &:hover {
    border: 1px solid ${(props) => darken(0.1, props.color)};
    color: ${(props) => darken(0.1, props.color)};
  }

  svg {
    color: ${(props) => props.color};
    margin-right: 0.25rem;
  }
`;

export default OutlinedButton;
